module.exports = __webpack_public_path__ + "static/media/ui-icons-more-off.4278bfef.svg";